// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

// Vite equivalent of Webpack's require.context
const modules = import.meta.glob('./**/*_channel.js', { eager: true })

Object.values(modules).forEach((module) => {
  // Each module is auto-registered when imported
})
